import { pluralize } from "@/modules/pluralize/pluralize";
import { CONTEXT_KIND_LABELS } from "@/store/note-version-history/constants";

interface FormatSnapshotAttributionArgs {
  editCount: number;
  authorName: string;
  isFirstVersion: boolean;
  contextKind: string | null | undefined;
  isAttributionEnabled: boolean;
}

const legacyLabel = (editCount: number, authorName: string): string => {
  const counted = `${editCount} ${pluralize(editCount, "edit", "edits")}`;
  return authorName ? `${counted} by ${authorName}` : counted;
};

export const formatSnapshotAttribution = ({
  editCount,
  authorName,
  isFirstVersion,
  contextKind,
  isAttributionEnabled,
}: FormatSnapshotAttributionArgs): string => {
  if (!isAttributionEnabled) {
    return legacyLabel(editCount, authorName);
  }

  if (!authorName) {
    return `${editCount} ${pluralize(editCount, "edit", "edits")}`;
  }

  const verbClause = isFirstVersion
    ? `Created by ${authorName}`
    : `${editCount} ${pluralize(editCount, "edit", "edits")} by ${authorName}`;

  const contextLabel = contextKind ? CONTEXT_KIND_LABELS[contextKind] : undefined;
  return contextLabel ? `${verbClause} via ${contextLabel}` : verbClause;
};
